module.exports = __webpack_public_path__ + "static/media/default_profile.de12e1dc.jpeg";